import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Link,
} from "@mui/material";
import { SplitGrid, StatGrid, PortalCard } from "./PortalUI";
import PortalPreviewBlur from "./PortalPreviewBlur";
export default function PortalBody({
  user,
  industry,
  theme,
  shell,
  displayName,
  authenticatedHero,
  heroBanner,
  isClaimModalOpen,
  setIsClaimModalOpen,
  claimType,
  setClaimType,
  setClaimStatusText,
  isCardLocked,
  setIsCardLocked,
  refillStatus,
  setRefillStatus,
  telehealthActive,
  setTelehealthActive,
  launchingApp,
  setLaunchingApp,
  transferTarget,
  setTransferTarget,
  transferAmount,
  setTransferAmount,
  transferSuccess,
  setTransferSuccess
}) {
  return user ? (
    <>
                {authenticatedHero}
                {industry === "finance" && <>
                <StatGrid sx={{ gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)" }, gap: { xs: 1.5, sm: 2.5 } }}>
                  {[{
            label: "Net Portfolio Value",
            value: "$1,248,392.40",
            change: "+2.45% past 24h",
            color: "#10b981"
          }, {
            label: "Available Liquid Cash",
            value: "$342,091.15",
            change: "Checking + Savings",
            color: "#64748b"
          }, {
            label: "Active Positions",
            value: "18 Positions",
            change: "12 Long, 6 Short",
            color: "#64748b"
          }, {
            label: "Authorized Credit Line",
            value: "$150,000.00",
            change: "0% APR promo",
            color: "#64748b"
          }].map(card => <PortalCard key={card.label} sx={{ p: { xs: 1.75, sm: 2.5 } }}>
                      <Typography variant="caption" sx={{ fontWeight: 700, color: "#64748b", textTransform: "uppercase", display: "block", mb: 0.75 }}>
                        {card.label}
                      </Typography>
                      <Typography sx={{ fontSize: { xs: "1.125rem", sm: "1.25rem" }, fontWeight: 900, color: theme.text, mb: 0.5 }}>
                        {card.value}
                      </Typography>
                      <Typography variant="caption" sx={{ fontWeight: 700, color: card.color }}>
                        {card.change}
                      </Typography>
                    </PortalCard>)}
                </StatGrid>

                <SplitGrid sx={{ mb: { xs: 2.5, md: 3.75 } }}>
                  <PortalCard sx={{ p: { xs: 2, sm: 3 } }}>
                    <Typography variant="h6" sx={{ fontSize: { xs: 15, sm: 16 }, fontWeight: 800, mb: 2 }}>
                      Asset Allocation
                    </Typography>
                    <Stack spacing={1.75}>
                      {[{
                label: "US Equities (TSLA, AAPL, MSFT)",
                value: "55%",
                fill: theme.primary,
                amount: "$686,615.82"
              }, {
                label: "Cash & Liquid Assets",
                value: "20%",
                fill: "#10b981",
                amount: "$249,678.48"
              }, {
                label: "Cryptocurrency (BTC, ETH)",
                value: "15%",
                fill: "#f59e0b",
                amount: "$187,258.86"
              }, {
                label: "Government Bonds",
                value: "10%",
                fill: "#64748b",
                amount: "$124,839.24"
              }].map(asset => <Box key={asset.label}>
                          <Stack
                            direction={{ xs: "column", sm: "row" }}
                            spacing={{ xs: 0.25, sm: 1 }}
                            sx={{ justifyContent: "space-between", alignItems: { xs: "flex-start", sm: "center" }, mb: 0.5 }}
                          >
                            <Typography variant="body2" sx={{ fontSize: { xs: 12, sm: 13 }, fontWeight: 600 }}>
                              {asset.label}
                            </Typography>
                            <Typography variant="body2" sx={{ fontWeight: 700, fontSize: { xs: 11, sm: 13 }, whiteSpace: { sm: "nowrap" } }}>
                              {asset.amount} ({asset.value})
                            </Typography>
                          </Stack>
                          <Box sx={{ width: "100%", height: 8, bgcolor: "#f1f5f9", borderRadius: 1, overflow: "hidden" }}>
                            <Box sx={{ width: asset.value, height: "100%", bgcolor: asset.fill, borderRadius: 1 }} />
                          </Box>
                        </Box>)}
                    </Stack>
                  </PortalCard>

                  <PortalCard sx={{ p: { xs: 2, sm: 3 }, display: "flex", flexDirection: "column", gap: 2.5 }}>
                    <Typography variant="h6" sx={{ fontSize: { xs: 15, sm: 16 }, fontWeight: 800 }}>
                      Quick Actions & Card Controls
                    </Typography>
                    <Box sx={{ p: 2, bgcolor: "#f8fafc", borderRadius: 1, border: "1px solid #e2e8f0" }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1.25 }}>
                        Transfer Funds
                      </Typography>
                      <Stack spacing={1.25}>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="Recipient Account #"
                          value={transferTarget}
                          onChange={(e) => setTransferTarget(e.target.value)}
                        />
                        <TextField
                          size="small"
                          fullWidth
                          type="number"
                          placeholder="Amount ($)"
                          value={transferAmount}
                          onChange={(e) => setTransferAmount(e.target.value)}
                        />
                        <Button
                          variant="contained"
                          fullWidth
                          onClick={() => {
                  if (!transferTarget || !transferAmount) return;
                  setTransferSuccess(true);
                  setTimeout(() => {
                    setTransferSuccess(false);
                    setTransferTarget("");
                    setTransferAmount("");
                  }, 3000);
                }}
                          sx={{ py: 1, bgcolor: theme.primary, fontWeight: 700, fontSize: 13 }}
                        >
                          Authorize Transfer
                        </Button>
                        {transferSuccess && (
                          <Typography variant="caption" sx={{ color: "#10b981", fontWeight: 700, textAlign: "center" }}>
                            ✓ Authorized via Secure LU biometric key!
                          </Typography>
                        )}
                      </Stack>
                    </Box>

                    <Stack
                      direction={{ xs: "column", sm: "row" }}
                      spacing={1.5}
                      sx={{ justifyContent: "space-between", alignItems: { xs: "stretch", sm: "center" }, p: 2, bgcolor: "#f8fafc", borderRadius: 1, border: "1px solid #e2e8f0" }}
                    >
                      <Box>
                        <Typography variant="body2" sx={{ fontWeight: 700 }}>
                          Titanium Debit Card
                        </Typography>
                        <Typography variant="caption" sx={{ color: "#64748b" }}>
                          Status: {isCardLocked ? "Locked 🔒" : "Active ✓"}
                        </Typography>
                      </Box>
                      <Button
                        variant="contained"
                        onClick={() => setIsCardLocked(!isCardLocked)}
                        sx={{
                          alignSelf: { xs: "stretch", sm: "center" },
                          px: 1.5,
                          py: 0.75,
                          borderRadius: 5,
                          fontWeight: 700,
                          fontSize: 11,
                          bgcolor: isCardLocked ? "#10b981" : "#dc2626",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {isCardLocked ? "Unlock Card" : "Freeze Card"}
                      </Button>
                    </Stack>
                  </PortalCard>
                </SplitGrid>

                <PortalCard sx={{ p: { xs: 2, sm: 3 } }}>
                  <Typography variant="h6" sx={{ fontSize: { xs: 15, sm: 16 }, fontWeight: 800, mb: 2 }}>
                    Recent Transactions
                  </Typography>

                  <Stack spacing={1.5} sx={{ display: { xs: "flex", md: "none" } }}>
                    {[{
                  merchant: "Apple Store",
                  date: "May 25, 2026",
                  cat: "Technology",
                  amt: "-$1,299.00",
                  status: "Completed",
                  sc: "#10b981",
                  sbg: "#10b98115"
                }, {
                  merchant: "LU Premium Service",
                  date: "May 24, 2026",
                  cat: "Security",
                  amt: "-$29.99",
                  status: "Completed",
                  sc: "#10b981",
                  sbg: "#10b98115"
                }, {
                  merchant: "Global Wire Deposit",
                  date: "May 22, 2026",
                  cat: "Income",
                  amt: "+$15,000.00",
                  status: "Completed",
                  sc: "#10b981",
                  sbg: "#10b98115"
                }, {
                  merchant: "Tesla Stocks fractional",
                  date: "May 20, 2026",
                  cat: "Investment",
                  amt: "-$3,500.00",
                  status: "Completed",
                  sc: "#10b981",
                  sbg: "#10b98115"
                }].map((tx, idx) => (
                      <Box
                        key={idx}
                        sx={{
                          p: 1.5,
                          borderRadius: 1.5,
                          border: "1px solid #f1f5f9",
                          bgcolor: "#fafbfc",
                        }}
                      >
                        <Stack direction="row" sx={{ justifyContent: "space-between", alignItems: "flex-start" }} spacing={1}>
                          <Box sx={{ minWidth: 0, flex: 1 }}>
                            <Typography variant="body2" sx={{ fontWeight: 700, lineHeight: 1.3 }}>
                              {tx.merchant}
                            </Typography>
                            <Typography variant="caption" sx={{ color: "#64748b" }}>
                              {tx.date}
                            </Typography>
                          </Box>
                          <Typography variant="body2" sx={{ fontWeight: 800, color: tx.amt.startsWith("+") ? "#10b981" : "#0f172a", flexShrink: 0 }}>
                            {tx.amt}
                          </Typography>
                        </Stack>
                        <Stack direction="row" spacing={1} sx={{ alignItems: "center", mt: 1 }}>
                          <Chip label={tx.cat} size="small" sx={{ height: 22, fontSize: 11, fontWeight: 600, bgcolor: "#f1f5f9" }} />
                          <Chip label={tx.status} size="small" sx={{ height: 22, fontSize: 11, fontWeight: 700, bgcolor: tx.sbg, color: tx.sc }} />
                        </Stack>
                      </Box>
                    ))}
                  </Stack>

                  <TableContainer sx={{ display: { xs: "none", md: "block" } }}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          {["Merchant", "Date", "Category", "Amount", "Status"].map((col) => (
                            <TableCell key={col} sx={{ fontWeight: 700, color: "#64748b" }}>{col}</TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {[{
                  merchant: "Apple Store",
                  date: "May 25, 2026",
                  cat: "Technology",
                  amt: "-$1,299.00",
                  status: "Completed",
                  sc: "#10b981",
                  sbg: "#10b98115"
                }, {
                  merchant: "LU Premium Service",
                  date: "May 24, 2026",
                  cat: "Security",
                  amt: "-$29.99",
                  status: "Completed",
                  sc: "#10b981",
                  sbg: "#10b98115"
                }, {
                  merchant: "Global Wire Deposit",
                  date: "May 22, 2026",
                  cat: "Income",
                  amt: "+$15,000.00",
                  status: "Completed",
                  sc: "#10b981",
                  sbg: "#10b98115"
                }, {
                  merchant: "Tesla Stocks fractional",
                  date: "May 20, 2026",
                  cat: "Investment",
                  amt: "-$3,500.00",
                  status: "Completed",
                  sc: "#10b981",
                  sbg: "#10b98115"
                }].map((tx, idx) => (
                          <TableRow key={idx}>
                            <TableCell sx={{ fontWeight: 700 }}>{tx.merchant}</TableCell>
                            <TableCell sx={{ color: "#64748b" }}>{tx.date}</TableCell>
                            <TableCell>
                              <Chip label={tx.cat} size="small" sx={{ height: 22, fontSize: 12, fontWeight: 600, bgcolor: "#f1f5f9" }} />
                            </TableCell>
                            <TableCell sx={{ fontWeight: 800, color: tx.amt.startsWith("+") ? "#10b981" : "#0f172a" }}>{tx.amt}</TableCell>
                            <TableCell>
                              <Chip label={tx.status} size="small" sx={{ height: 22, fontSize: 11, fontWeight: 700, bgcolor: tx.sbg, color: tx.sc }} />
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </PortalCard>
                  </>}
                {industry === "healthcare" && <>
              <SplitGrid sx={{ gap: { xs: 3, md: 5 } }}>
                <Stack spacing={{ xs: 2.5, md: 3.75 }}>
                  <PortalCard sx={{ p: { xs: 2, sm: 3 }, borderColor: "#e9efef" }}>
                    <Typography variant="h6" sx={{ fontSize: { xs: 16, sm: 18 }, fontWeight: 800, color: theme.primary, mb: 2 }}>
                      Appointments & Active Consultations
                    </Typography>
                    <Stack
                      direction={{ xs: "column", sm: "row" }}
                      spacing={2}
                      sx={{ bgcolor: "#f0fdfa", p: { xs: 1.5, sm: 2.5 }, borderRadius: 2, border: `1.5px solid ${theme.primary}22` }}
                    >
                      <Typography sx={{ fontSize: { xs: 28, sm: 32 }, lineHeight: 1 }}>🩺</Typography>
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography sx={{ fontSize: { xs: 14, sm: 16 }, fontWeight: 800, color: theme.text }}>
                          Cardiology Consultation Checkup
                        </Typography>
                        <Typography variant="body2" sx={{ fontSize: 13, color: "#64748b", mt: 0.25 }}>
                          Dr. Sarah Jenkins • Room #4 Telehealth Terminal
                        </Typography>
                        <Stack direction={{ xs: "column", sm: "row" }} spacing={1} sx={{ mt: 1.5 }}>
                          <Button variant="contained" onClick={() => setTelehealthActive(true)} sx={{ py: 1, px: 2, bgcolor: theme.primary, borderRadius: 5, fontWeight: 800, fontSize: 13 }}>
                            {telehealthActive ? "✓ Active Room Joined" : "Join Secure Video Consult"}
                          </Button>
                          <Button variant="outlined" sx={{ py: 1, px: 2, color: theme.primary, borderColor: theme.primary, borderRadius: 5, fontWeight: 800, fontSize: 13 }}>
                            Reschedule
                          </Button>
                        </Stack>
                      </Box>
                      <Chip label="TODAY 2:30 PM" size="small" sx={{ alignSelf: { xs: "flex-start", sm: "flex-start" }, bgcolor: theme.primary, color: "#fff", fontWeight: 800, fontSize: 11 }} />
                    </Stack>
                    {telehealthActive && (
                      <Box sx={{ mt: 2, bgcolor: "#0f172a", borderRadius: 2, height: { xs: 180, sm: 240 }, position: "relative", overflow: "hidden", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <Box sx={{ position: "absolute", inset: 0, opacity: 0.7, background: "radial-gradient(circle, rgba(13,148,136,0.3) 0%, rgba(0,0,0,0.8) 100%)" }} />
                        <Box sx={{ zIndex: 1, color: "#fff", textAlign: "center", px: 2 }}>
                          <Typography sx={{ fontSize: 36 }}>👩‍⚕️</Typography>
                          <Typography sx={{ fontWeight: 800, fontSize: 16, mt: 1 }}>Dr. Sarah Jenkins is waiting...</Typography>
                          <Typography sx={{ fontSize: 12, color: "#2dd4bf", mt: 0.5 }}>Biometric security handshake complete. Secure stream active.</Typography>
                          <Button variant="contained" onClick={() => setTelehealthActive(false)} sx={{ mt: 1.5, py: 0.75, px: 1.75, bgcolor: "#ef4444", borderRadius: 5, fontWeight: 700, fontSize: 11 }}>
                            Disconnect Call
                          </Button>
                        </Box>
                      </Box>
                    )}
                  </PortalCard>

                  <PortalCard sx={{ p: { xs: 2, sm: 3 }, borderColor: "#e9efef" }}>
                    <Typography variant="h6" sx={{ fontSize: { xs: 16, sm: 18 }, fontWeight: 800, color: theme.primary, mb: 2 }}>
                      Continuous Vitals Monitoring
                    </Typography>
                    <Grid container spacing={2}>
                      {[{
                  label: "Blood Pressure",
                  val: "120/80 mmHg",
                  status: "Optimal",
                  color: "#10b981",
                  bg: "#10b98110"
                }, {
                  label: "Resting Heart Rate",
                  val: "72 bpm",
                  status: "Stable",
                  color: "#10b981",
                  bg: "#10b98110"
                }, {
                  label: "Fasting Blood Sugar",
                  val: "94 mg/dL",
                  status: "Normal",
                  color: "#10b981",
                  bg: "#10b98110"
                }, {
                  label: "Blood Oxygen SpO2",
                  val: "99%",
                  status: "Excellent",
                  color: "#10b981",
                  bg: "#10b98110"
                }].map(vital => (
                        <Grid key={vital.label} size={{ xs: 12, sm: 6 }}>
                          <Box sx={{ bgcolor: "#fcfdfe", p: 2, borderRadius: 1.75, border: "1px solid #e2e8f0", height: "100%" }}>
                            <Typography variant="caption" sx={{ fontWeight: 700, color: "#64748b", textTransform: "uppercase" }}>{vital.label}</Typography>
                            <Typography sx={{ fontSize: { xs: 18, sm: 20 }, fontWeight: 800, color: theme.text, my: 0.75 }}>{vital.val}</Typography>
                            <Chip label={vital.status} size="small" sx={{ bgcolor: vital.bg, color: vital.color, fontWeight: 700, fontSize: 11, height: 22 }} />
                          </Box>
                        </Grid>
                      ))}
                    </Grid>
                  </PortalCard>
                </Stack>

                <Stack spacing={{ xs: 2.5, md: 3.75 }}>
                  <PortalCard sx={{ p: { xs: 2, sm: 3 }, borderColor: "#e9efef" }}>
                    <Typography variant="h6" sx={{ fontSize: { xs: 16, sm: 18 }, fontWeight: 800, color: theme.primary, mb: 2 }}>
                      Active Prescriptions
                    </Typography>
                    <Stack spacing={1.5}>
                      {[{
                  id: 1,
                  name: "Lisinopril 10mg",
                  schedule: "Once daily (Morning)",
                  refill: "2 Refills left"
                }, {
                  id: 2,
                  name: "Atorvastatin 20mg",
                  schedule: "Once daily (Night)",
                  refill: "5 Refills left"
                }, {
                  id: 3,
                  name: "Omega 3 Fish Oil",
                  schedule: "Twice daily (Meal)",
                  refill: "No Rx required"
                }].map(rx => (
                        <Stack key={rx.id} direction={{ xs: "column", sm: "row" }} spacing={1} sx={{ justifyContent: "space-between", alignItems: { xs: "stretch", sm: "flex-start" }, p: 1.75, border: "1px solid #f1f5f9", borderRadius: 1.5, bgcolor: "#fbfdfd" }}>
                          <Box sx={{ minWidth: 0 }}>
                            <Typography sx={{ fontWeight: 800, fontSize: 14 }}>{rx.name}</Typography>
                            <Typography variant="caption" sx={{ color: "#64748b" }}>{rx.schedule} • {rx.refill}</Typography>
                          </Box>
                          <Button
                            variant="contained"
                            disabled={refillStatus[rx.id]}
                            onClick={() => setRefillStatus(prev => ({ ...prev, [rx.id]: "Requested" }))}
                            sx={{ alignSelf: { xs: "stretch", sm: "flex-start" }, py: 0.75, px: 1.5, borderRadius: 5, fontWeight: 700, fontSize: 11, bgcolor: refillStatus[rx.id] ? "#10b98115" : `${theme.primary}12`, color: refillStatus[rx.id] ? "#10b981" : theme.primary, boxShadow: "none" }}
                          >
                            {refillStatus[rx.id] ? "✓ Refill Sent" : "Request Refill"}
                          </Button>
                        </Stack>
                      ))}
                    </Stack>
                  </PortalCard>

                  <PortalCard sx={{ p: { xs: 2, sm: 3 }, borderColor: "#e9efef" }}>
                    <Typography variant="h6" sx={{ fontSize: { xs: 16, sm: 18 }, fontWeight: 800, color: theme.primary, mb: 2 }}>
                      Diagnostics Reports
                    </Typography>
                    <Stack spacing={1.25}>
                      {[{
                  title: "Complete Lipid Panel Result",
                  date: "May 24, 2026",
                  cert: "LU-SIGN"
                }, {
                  title: "Cardio stress ECG Report",
                  date: "May 10, 2026",
                  cert: "LU-SIGN"
                }].map(rep => (
                        <Stack key={rep.title} direction="row" spacing={1} sx={{ justifyContent: "space-between", alignItems: "flex-start", p: 1.75, bgcolor: "#f8fafc", borderRadius: 1.25, border: "1px solid #e2e8f0" }}>
                          <Box sx={{ minWidth: 0, flex: 1 }}>
                            <Typography sx={{ fontSize: 13, fontWeight: 800 }}>{rep.title}</Typography>
                            <Typography variant="caption" sx={{ color: "#64748b" }}>Uploaded {rep.date}</Typography>
                          </Box>
                          <Stack sx={{ alignItems: "flex-end" }} spacing={0.5}>
                            <Chip label={rep.cert} size="small" sx={{ bgcolor: "rgba(16,185,129,0.15)", color: "#10b981", fontWeight: 800, fontSize: 10, height: 20 }} />
                            <Link href="#" onClick={e => e.preventDefault()} sx={{ fontSize: 11, color: theme.primary, fontWeight: 700 }} underline="none">Download</Link>
                          </Stack>
                        </Stack>
                      ))}
                    </Stack>
                  </PortalCard>
                </Stack>
              </SplitGrid>
                  </>}
                {industry === "government" && <>
              <SplitGrid columns="1fr 1fr" sx={{ gap: { xs: 3, md: 4 } }}>
                <PortalCard sx={{ p: { xs: 2, sm: 3 } }}>
                  <Typography variant="h6" sx={{ fontSize: { xs: 16, sm: 18 }, fontWeight: 800, color: theme.text, fontFamily: "serif", pb: 1.5, mb: 2, borderBottom: "1px solid #e2e8f0" }}>
                    Verified Citizen Credentials
                  </Typography>
                  <Stack spacing={1.5}>
                    {[{
              title: "National Digital Passport",
              id: "PPT-US-890281-Z",
              exp: "Valid until Jan 2031",
              icon: "🛂"
            }, {
              title: "Universal Driver's License",
              id: "DL-9082910-X",
              exp: "Class C • Valid until Jun 2029",
              icon: "🚘"
            }, {
              title: "Universal Health Insurance ID",
              id: "HLT-003928-Q",
              exp: "Active Coverage Profile",
              icon: "🏥"
            }].map(cred => (
                      <Stack key={cred.id} direction="row" spacing={1.5} sx={{ p: 2, borderRadius: 1.25, border: "1px solid #f1f5f9", bgcolor: "#f8fafc" }}>
                        <Typography sx={{ fontSize: { xs: 24, sm: 28 }, lineHeight: 1 }}>{cred.icon}</Typography>
                        <Box sx={{ minWidth: 0 }}>
                          <Typography sx={{ fontSize: { xs: 14, sm: 15 }, fontWeight: 800, color: theme.text }}>{cred.title}</Typography>
                          <Typography variant="caption" sx={{ color: "#64748b", display: "block", wordBreak: "break-all" }}>ID Number: {cred.id}</Typography>
                          <Typography variant="caption" sx={{ color: "#10b981", fontWeight: 700 }}>{cred.exp}</Typography>
                        </Box>
                      </Stack>
                    ))}
                  </Stack>
                </PortalCard>

                <Stack spacing={{ xs: 2.5, md: 3 }}>
                  <PortalCard sx={{ p: { xs: 2, sm: 3 } }}>
                    <Typography variant="h6" sx={{ fontSize: { xs: 16, sm: 18 }, fontWeight: 800, color: theme.text, fontFamily: "serif", pb: 1.5, mb: 2, borderBottom: "1px solid #e2e8f0" }}>
                      Official Document Registry Vault
                    </Typography>
                    <Typography variant="body2" sx={{ fontSize: 13, color: "#64748b", mb: 2, lineHeight: 1.5 }}>
                      Download government-stamped documents securely. Each document is cryptographically verified using LegitimatelyU blockchain audit nodes.
                    </Typography>
                    <Stack spacing={1.25}>
                      {[{
                  doc: "Federal Income Tax Transcript (2025)",
                }, {
                  doc: "Real Estate Deed Certificate",
                }, {
                  doc: "National Social Security Ledger",
                }].map((item, idx) => (
                        <Stack key={idx} direction={{ xs: "column", sm: "row" }} spacing={1} sx={{ justifyContent: "space-between", alignItems: { xs: "stretch", sm: "center" }, p: 1.75, borderRadius: 1, border: "1px solid #e2e8f0", bgcolor: "#f8fafc" }}>
                          <Box sx={{ minWidth: 0 }}>
                            <Typography sx={{ fontSize: 13, fontWeight: 700, color: theme.text }}>{item.doc}</Typography>
                            <Typography variant="caption" sx={{ color: "#10b981", fontWeight: 700 }}>✓ LU Sign-Verified</Typography>
                          </Box>
                          <Button variant="contained" size="small" sx={{ alignSelf: { xs: "stretch", sm: "center" }, bgcolor: theme.primary, fontWeight: 700, fontSize: 11, px: 1.75 }}>
                            Download
                          </Button>
                        </Stack>
                      ))}
                    </Stack>
                  </PortalCard>

                  <PortalCard sx={{ p: { xs: 2, sm: 3 } }}>
                    <Typography variant="h6" sx={{ fontSize: { xs: 16, sm: 18 }, fontWeight: 800, color: theme.text, fontFamily: "serif", pb: 1.5, mb: 2, borderBottom: "1px solid #e2e8f0" }}>
                      Portal Administrative Log
                    </Typography>
                    <Box sx={{ bgcolor: "#eff6ff", border: "1px solid #bfdbfe", p: 2, borderRadius: 1, fontSize: { xs: 11, sm: 12 }, color: "#1e3a8a", lineHeight: 1.6 }}>
                      <strong>NOTICE:</strong> Biometric login session was authenticated on <strong>May 26, 2026</strong>. The cryptographic handshakes confirm physical presence. Citizen digital portal is fully active under security Level 3.
                    </Box>
                  </PortalCard>
                </Stack>
              </SplitGrid>
                  </>}
                {industry === "insurance" && <>
              <SplitGrid columns="1.1fr 0.9fr" sx={{ gap: { xs: 3, md: 5 } }}>
                <Stack spacing={{ xs: 2.5, md: 3.75 }}>
                  <PortalCard sx={{ p: { xs: 2, sm: 3 }, borderColor: "#f1e9d2" }}>
                    <Typography variant="h6" sx={{ fontSize: { xs: 16, sm: 18 }, fontWeight: 800, color: theme.text, mb: 2 }}>
                      Your Active Policies
                    </Typography>
                    <Grid container spacing={2}>
                      {[{
                  title: "Auto Insurance Premium",
                  cover: "$250,000 Liability",
                  item: "Tesla Model 3 (2023)",
                  id: "POL-003921"
                }, {
                  title: "Homeowners Gold Coverage",
                  cover: "$750,000 Replacement",
                  item: "Primary Residence",
                  id: "POL-992019"
                }].map(pol => (
                        <Grid key={pol.id} size={{ xs: 12, sm: 6 }}>
                          <Box sx={{ p: 2, border: "1px solid #f1f5f9", borderRadius: 1.5, bgcolor: "#faf8f5", height: "100%" }}>
                            <Typography sx={{ fontWeight: 800, fontSize: { xs: 14, sm: 15 }, color: theme.text }}>{pol.title}</Typography>
                            <Typography sx={{ fontSize: 13, fontWeight: 600, color: theme.primary, mt: 1 }}>{pol.cover}</Typography>
                            <Typography sx={{ fontSize: 12, color: "#64748b", mt: 0.25 }}>{pol.item}</Typography>
                            <Box sx={{ borderTop: "1px dashed #cbd5e1", mt: 1.5, pt: 1, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                              <Typography variant="caption" sx={{ color: "#94a3b8" }}>ID: {pol.id}</Typography>
                              <Typography variant="caption" sx={{ color: "#10b981", fontWeight: 800 }}>✓ ACTIVE</Typography>
                            </Box>
                          </Box>
                        </Grid>
                      ))}
                    </Grid>
                  </PortalCard>

                  <PortalCard sx={{ p: { xs: 2, sm: 3 }, borderColor: "#f1e9d2" }}>
                    <Typography variant="h6" sx={{ fontSize: { xs: 16, sm: 18 }, fontWeight: 800, color: theme.text, mb: 2 }}>
                      Active Claims Tracker
                    </Typography>
                    <Box sx={{ bgcolor: "#faf8f5", p: { xs: 1.5, sm: 2.5 }, borderRadius: 1.5, border: "1px solid #cbd5e1" }}>
                      <Stack direction={{ xs: "column", sm: "row" }} spacing={1} sx={{ justifyContent: "space-between", alignItems: { xs: "flex-start", sm: "center" }, mb: 2 }}>
                        <Box>
                          <Typography sx={{ fontSize: 14, fontWeight: 800 }}>Claim #CLM-2026-092</Typography>
                          <Typography variant="caption" sx={{ color: "#64748b" }}>Type: Auto Property Damage</Typography>
                        </Box>
                        <Chip label="APPROVED" size="small" sx={{ bgcolor: "#10b98115", color: "#10b981", fontWeight: 800, fontSize: 11 }} />
                      </Stack>

                      <Stack spacing={1.5} sx={{ display: { xs: "flex", md: "none" } }}>
                        {[{ label: "Filed", date: "May 14" }, { label: "Review", date: "May 16" }, { label: "Assessment", date: "May 18" }, { label: "Payout", date: "May 22" }].map((st) => (
                          <Stack key={st.label} direction="row" spacing={1.5} sx={{ alignItems: "center" }}>
                            <Box sx={{ width: 26, height: 26, borderRadius: "50%", bgcolor: theme.primary, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 800, flexShrink: 0 }}>✓</Box>
                            <Box>
                              <Typography variant="body2" sx={{ fontWeight: 700, fontSize: 13 }}>{st.label}</Typography>
                              <Typography variant="caption" sx={{ color: "#64748b" }}>{st.date}</Typography>
                            </Box>
                          </Stack>
                        ))}
                      </Stack>

                      <Box sx={{ display: { xs: "none", md: "flex" }, justifyContent: "space-between", position: "relative" }}>
                        <Box sx={{ position: "absolute", top: 12, left: 20, right: 20, height: 2, bgcolor: theme.primary, zIndex: 0 }} />
                        {[{ label: "Filed", date: "May 14" }, { label: "Review", date: "May 16" }, { label: "Assessment", date: "May 18" }, { label: "Payout", date: "May 22" }].map((st) => (
                          <Box key={st.label} sx={{ display: "flex", flexDirection: "column", alignItems: "center", zIndex: 1 }}>
                            <Box sx={{ width: 26, height: 26, borderRadius: "50%", bgcolor: theme.primary, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 800 }}>✓</Box>
                            <Typography sx={{ fontSize: 12, fontWeight: 700, mt: 0.75 }}>{st.label}</Typography>
                            <Typography sx={{ fontSize: 11, color: "#64748b" }}>{st.date}</Typography>
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  </PortalCard>
                </Stack>

                <Stack spacing={{ xs: 2.5, md: 3.75 }}>
                  <PortalCard sx={{ p: { xs: 2, sm: 3 }, borderColor: "#f1e9d2" }}>
                    <Typography variant="h6" sx={{ fontSize: { xs: 16, sm: 18 }, fontWeight: 800, color: theme.text, mb: 1.5 }}>
                      Claim Management
                    </Typography>
                    <Typography variant="body2" sx={{ fontSize: 13, color: "#64748b", mb: 2.5, lineHeight: 1.5 }}>
                      File claims directly and authorize digital identity signature via LegitimatelyU biometric key.
                    </Typography>
                    <Stack spacing={1.5}>
                      <Button variant="contained" fullWidth onClick={() => setIsClaimModalOpen(true)} sx={{ py: 1.25, bgcolor: theme.primary, fontWeight: 800 }}>
                        File a New Claim
                      </Button>
                      <Button variant="outlined" fullWidth sx={{ py: 1.25, color: theme.primary, borderColor: theme.primary, borderWidth: 1.5, fontWeight: 800 }}>
                        Get Emergency Roadside Assistance
                      </Button>
                    </Stack>
                  </PortalCard>

                  <PortalCard sx={{ p: { xs: 2, sm: 3 }, borderColor: "#f1e9d2" }}>
                    <Typography variant="h6" sx={{ fontSize: { xs: 16, sm: 18 }, fontWeight: 800, color: theme.text, mb: 2 }}>
                      Billing & Policy Statements
                    </Typography>
                    <Stack spacing={1.25} divider={<Box sx={{ borderBottom: "1px solid #f1f5f9" }} />}>
                      {[{
                  billing: "Premium Invoice - May 2026",
                  amt: "$350.00",
                  date: "Paid May 15"
                }, {
                  billing: "Policy Renewal Summary",
                  amt: "N/A",
                  date: "Issued Apr 12"
                }].map(stmt => (
                        <Stack key={stmt.billing} direction="row" spacing={1} sx={{ justifyContent: "space-between", alignItems: "flex-start", py: 0.5 }}>
                          <Box sx={{ minWidth: 0, flex: 1 }}>
                            <Typography sx={{ fontSize: 13, fontWeight: 800 }}>{stmt.billing}</Typography>
                            <Typography variant="caption" sx={{ color: "#64748b" }}>{stmt.date}</Typography>
                          </Box>
                          <Box sx={{ textAlign: "right", flexShrink: 0 }}>
                            <Typography sx={{ fontSize: 14, fontWeight: 800 }}>{stmt.amt}</Typography>
                            <Link href="#" onClick={e => e.preventDefault()} sx={{ fontSize: 11, color: theme.primary, fontWeight: 700 }} underline="none">PDF</Link>
                          </Box>
                        </Stack>
                      ))}
                    </Stack>
                  </PortalCard>
                </Stack>
              </SplitGrid>

              <Dialog open={isClaimModalOpen} onClose={() => setIsClaimModalOpen(false)} maxWidth="xs" fullWidth>
                <DialogTitle sx={{ fontWeight: 800 }}>Submit New Incident Claim</DialogTitle>
                <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <Typography variant="body2" color="text.secondary">
                    This claim requires LegitimatelyU biometric signature validation.
                  </Typography>
                  <TextField
                    select
                    label="Incident Type"
                    value={claimType}
                    onChange={(e) => setClaimType(e.target.value)}
                    size="small"
                    fullWidth
                  >
                    <MenuItem value="Auto">Auto Incident</MenuItem>
                    <MenuItem value="Home">Home Damage</MenuItem>
                    <MenuItem value="Personal">Liability / Medical</MenuItem>
                  </TextField>
                  <TextField
                    label="Incident Description"
                    placeholder="Please describe what happened..."
                    multiline
                    rows={3}
                    fullWidth
                    size="small"
                  />
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2, flexDirection: "column", gap: 1, alignItems: "stretch" }}>
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={() => {
                      setClaimStatusText(`Your new ${claimType} claim has been filed and signed.`);
                      setIsClaimModalOpen(false);
                      alert("Claim submitted and biometrically signed via LU Session Token successfully!");
                    }}
                    sx={{ fontWeight: 800 }}
                  >
                    Authorize & Sign Claim
                  </Button>
                  <Button onClick={() => setIsClaimModalOpen(false)} sx={{ color: "text.secondary" }}>
                    Cancel
                  </Button>
                </DialogActions>
              </Dialog>
                  </>}
                {industry === "corporate" && <>
              <SplitGrid sx={{ gap: { xs: 3, md: 5 } }}>
                <Stack spacing={{ xs: 2.5, md: 3.75 }}>
                  <PortalCard dark sx={{ p: { xs: 2, sm: 3 }, borderColor: "rgba(99,102,241,0.15)" }}>
                    <Typography variant="h6" sx={{ fontSize: { xs: 16, sm: 18 }, fontWeight: 800, color: "#a855f7", mb: 1 }}>
                      Unified Single Sign-On Apps
                    </Typography>
                    <Typography variant="body2" sx={{ fontSize: 13, color: "#94a3b8", mb: 2.5 }}>
                      Click to securely launch any enterprise app using LegitimatelyU credential tunneling.
                    </Typography>
                    <Grid container spacing={1.5}>
                      {[
                  { name: "Slack Enterprise", desc: "Staff Communication" },
                  { name: "GitHub Dev Node", desc: "Corporate Repositories" },
                  { name: "AWS Console", desc: "Cloud Resources" },
                  { name: "Jira Software", desc: "Product Tracking" },
                  { name: "Figma Design", desc: "Product UX Assets" },
                  { name: "Datadog Stats", desc: "Server Analytics" },
                ].map(app => (
                        <Grid key={app.name} size={{ xs: 12, sm: 6, md: 4 }}>
                          <Button
                            variant="contained"
                            fullWidth
                            onClick={() => {
                              setLaunchingApp(app.name);
                              setTimeout(() => setLaunchingApp(null), 1500);
                            }}
                            sx={{
                              p: 2,
                              borderRadius: 1.5,
                              bgcolor: "rgba(30,41,59,0.5)",
                              border: "1px solid rgba(255,255,255,0.05)",
                              textAlign: "left",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "flex-start",
                              color: "#f8fafc",
                              boxShadow: "none",
                              "&:hover": { bgcolor: "rgba(30,41,59,0.8)", borderColor: "#6366f1" },
                            }}
                          >
                            <Typography sx={{ fontWeight: 800, fontSize: 14 }}>{app.name}</Typography>
                            <Typography sx={{ fontSize: 11, color: "#94a3b8", mt: 0.5 }}>{app.desc}</Typography>
                            <Stack direction="row" sx={{ justifyContent: "space-between", alignItems: "center", width: "100%", mt: 1.5 }}>
                              <Chip label="Active" size="small" sx={{ height: 18, fontSize: 9, bgcolor: "rgba(16,185,129,0.15)", color: "#10b981", fontWeight: 800 }} />
                              <Typography sx={{ color: "#6366f1", fontSize: 11, fontWeight: 800 }}>LAUNCH →</Typography>
                            </Stack>
                          </Button>
                        </Grid>
                      ))}
                    </Grid>
                  </PortalCard>

                  {launchingApp && (
                    <Box sx={{ p: 2, bgcolor: "rgba(99,102,241,0.15)", border: "1px solid rgba(99,102,241,0.3)", borderRadius: 1.5, display: "flex", alignItems: "center", gap: 1.5 }}>
                      <CircularProgress size={16} sx={{ color: "#fff", flexShrink: 0 }} />
                      <Typography variant="body2" sx={{ fontSize: 13, fontWeight: 700, color: "#f8fafc" }}>
                        Securely authenticating connection to {launchingApp} via LU Biometric Tunnel...
                      </Typography>
                    </Box>
                  )}
                </Stack>

                <Stack spacing={{ xs: 2.5, md: 3.75 }}>
                  <PortalCard dark sx={{ p: { xs: 2, sm: 3 }, borderColor: "rgba(99,102,241,0.15)" }}>
                    <Typography variant="h6" sx={{ fontSize: { xs: 15, sm: 16 }, fontWeight: 800, color: "#a855f7", mb: 2 }}>
                      Corporate Device Security
                    </Typography>
                    <Stack spacing={1.25}>
                      {[
                  { label: "Hardware Model", val: "Apple MacBook Pro (M3)" },
                  { label: "Firewall / Encryption", val: "ACTIVE / FileVault On" },
                  { label: "Hardware Trust Module", val: "Verified Enclave Active" },
                ].map(sec => (
                        <Stack key={sec.label} direction={{ xs: "column", sm: "row" }} spacing={0.5} sx={{ justifyContent: "space-between", pb: 1, borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
                          <Typography variant="body2" sx={{ color: "#94a3b8", fontSize: 12 }}>{sec.label}</Typography>
                          <Typography variant="body2" sx={{ fontWeight: 700, fontSize: 12, color: "#f8fafc", textAlign: { xs: "left", sm: "right" } }}>{sec.val}</Typography>
                        </Stack>
                      ))}
                    </Stack>
                  </PortalCard>

                  <PortalCard dark sx={{ p: { xs: 2, sm: 3 }, borderColor: "rgba(99,102,241,0.15)" }}>
                    <Typography variant="h6" sx={{ fontSize: { xs: 15, sm: 16 }, fontWeight: 800, color: "#a855f7", mb: 2 }}>
                      Session Audit Trail
                    </Typography>
                    <Stack spacing={1.25}>
                      {[
                  { event: "SSO Launch - Slack", time: "Today, 08:47:10", details: "LU Authed" },
                  { event: "Session Handshake", time: "Today, 08:45:12", details: "Biometric Success" },
                  { event: "Device Compliance check", time: "Today, 08:45:00", details: "Passed" },
                ].map((log, idx) => (
                        <Stack key={idx} direction="row" spacing={1} sx={{ justifyContent: "space-between", alignItems: "flex-start" }}>
                          <Box sx={{ minWidth: 0 }}>
                            <Typography sx={{ fontWeight: 800, fontSize: 13, color: "#f8fafc" }}>{log.event}</Typography>
                            <Typography variant="caption" sx={{ color: "#94a3b8" }}>{log.time}</Typography>
                          </Box>
                          <Typography variant="body2" sx={{ color: "#10b981", fontWeight: 700, fontSize: 12, flexShrink: 0 }}>{log.details}</Typography>
                        </Stack>
                      ))}
                    </Stack>
                  </PortalCard>
                </Stack>
              </SplitGrid>
                  </>}
              </>
  ) : (
    <>
                {heroBanner}
                <PortalPreviewBlur industry={industry} theme={theme} />
              </>
  );
}